var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.8 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #008060;\n      }\n\n      .st1 {\n        stroke-linejoin: round;\n      }\n\n      .st1, .st2 {\n        fill: none;\n        stroke: #008060;\n        stroke-linecap: round;\n        stroke-width: 1.2px;\n      }\n\n      .st2 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.5,14.5v-5.1h3.8v.9H1.5v1.1h2.6v.9H1.5v1.4h2.9v.9H.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,12.6l1,.3c-.2.6-.4,1-.8,1.3-.4.3-.8.4-1.4.4s-1.2-.2-1.7-.7c-.4-.5-.7-1.1-.7-1.9s.2-1.5.7-2c.4-.5,1-.7,1.7-.7s1.1.2,1.5.6c.2.2.4.5.5.9l-1,.2c0-.3-.2-.5-.4-.6-.2-.2-.4-.2-.7-.2s-.7.1-.9.4c-.2.3-.4.7-.4,1.3s.1,1.1.4,1.4c.2.3.5.4.9.4s.5,0,.7-.3c.2-.2.3-.5.4-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,11.9c0-.5,0-1,.2-1.3.1-.3.3-.5.5-.7.2-.2.4-.4.7-.5.3-.1.7-.2,1.1-.2.8,0,1.4.2,1.8.7.5.5.7,1.1.7,2s-.2,1.5-.7,2c-.5.5-1.1.7-1.8.7s-1.4-.2-1.8-.7c-.5-.5-.7-1.1-.7-1.9ZM11.3,11.9c0,.6.1,1,.4,1.3s.6.5,1,.5.8-.1,1-.4c.3-.3.4-.7.4-1.3s-.1-1-.4-1.3c-.3-.3-.6-.4-1-.4s-.8.1-1,.4c-.3.3-.4.7-.4,1.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.1,7.3s.2-1.4,1.3-2.3,2.8-1.4,5.1-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,6.9s.5.6,1.7.8,2.4-.2,2.9-.5c.7-.4,1.5-1.4,1.9-1.9s2.1-1.3,2.6-1.2c0,0-1.2-2.3-3.7-3s-4.1-.5-5.3.5-1.6,2.4-1.8,3.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEco);
export default __webpack_public_path__ + "static/media/icon_eco.08fd1fb30147fc6f6b7ba46486271e4f.svg";
export { ForwardRef as ReactComponent };